import { FileActionEnum } from "enums/FileActionEnum";
import { SendTypeEnum } from "enums/MethodSendEmailEnum";
import { RunStatusEnum } from "enums/RunStatusEnum";
import { SendToEnum } from "enums/SendToEnum";
import { createContext } from "react";

export interface IEnumLabelsContext {
  getBoardRole: (roleId: number) => string;
  getBoardStatus: (state: boolean, archivedDate?: string | null) => string;
  getBoardTitle: (s: string) => string;
  getRunRole: (roleId: number) => string;
  getRunTitle: (s: string) => string;
  getRunStatus: (status: RunStatusEnum) => string;
  getRunStatusBadgeTitle: (status: RunStatusEnum, archivedDate: string | undefined) => string;
  getRunStatusChangeConfirmText: (status: RunStatusEnum) => string;
  getRunStatusChangeConfirmTitle: (status: RunStatusEnum) => string;
  getRunTopicCode: (s: string) => string;
  getTopicType: (key: string) => string;
  getTopicContentTitle: (key: string) => string;
  getFileAction: (status: FileActionEnum | undefined) => string;
  getSendType: (value: SendTypeEnum) => string;
  getSendTo: (value: SendToEnum) => string;
}

export const EnumLabelsContext = createContext<IEnumLabelsContext | undefined>(undefined);
